import React, {Fragment} from 'react';
import Toggle from 'react-toggle';

import './Checkbox.scss';

export default (field) => {
  const handleChange = (e) => {
    field.input.onChange(e);
    if (field.customOnChange) {
      setTimeout(() => {
        field.customOnChange(e);
      }, 0)
    }
  };
  
  return (
    <Fragment>
      <label className="d-flex justify-content-between align-items-center my-1">
        <span>{field.label}</span>
        <Toggle
          icons={true}
          checked={!!field.input.value}
          onChange={handleChange}
          disabled={!!field.disabled}
        />
      </label>
      {field.separator && <div className="bg-gray-200 separator-x w-100"/>}
    </Fragment>
  );
};